import React, { useState, useEffect } from "react";
import { serverFetch } from "@extensions";
import { useCompany, useUser } from "@redux";
import { Image, Spin, message } from "antd";
import dayjs from "dayjs";
import "./catalog-sale-users.css";

const CatalogSaleUsers = ({ productId, selectedDate, onSelect }) => {
  const company = useCompany();
  const user = useUser();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  useEffect(() => {
    if (productId && selectedDate && company) {
      fetchUsers();
    } else {
      setUsers([]);
      setSelectedUserId(null);
    }
  }, [productId, selectedDate, company]);

  const fetchUsers = async () => {
    if (!company || !productId || !selectedDate) return;

    setLoading(true);
    try {
      const queryParams = {
        productId: productId,
        date: selectedDate.format("YYYY-MM-DD"),
      };
      const data = await serverFetch("Online/ProductUsers", { method: "GET", queryParams: queryParams }, user);
      setUsers(data || []);
      if (data && data.length > 0 && !selectedUserId) {
        setSelectedUserId(data[0].id);
        if (onSelect) {
          onSelect(data[0]);
        }
      }
    } catch (error) {
      console.error("Ошибка получения сотрудников:", error);
      message.error(error?.UserMessage || "Не удалось загрузить список сотрудников");
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  const handleUserSelect = (user) => {
    setSelectedUserId(user.id);
    if (onSelect) {
      onSelect(user);
    }
  };

  if (loading) {
    return (
      <div className="catalog-sale-users-loading">
        <Spin size="small" />
      </div>
    );
  }

  if (!users || users.length === 0) {
    return null;
  }

  return (
    <div className="catalog-sale-users">
      <div className="catalog-sale-users-title">Выберите сотрудника</div>
      <div className="catalog-sale-users-list">
        {users.map((u) => (
          <div
            key={u.id}
            className={`catalog-sale-users-card ${selectedUserId === u.id ? "selected" : ""}`}
            onClick={() => handleUserSelect(u)}
          >
            {u.imageId && (
              <div className="catalog-sale-users-photo">
                <Image
                  src={`${process.env.REACT_APP_API_BASE_URL}/api/image/${u.imageId}`}
                  alt={u.name}
                  preview={false}
                  className="catalog-sale-users-image"
                />
              </div>
            )}
            <div className="catalog-sale-users-info">
              <div className="catalog-sale-users-name">{u.name}</div>
              {u.position && <div className="catalog-sale-users-position">{u.position}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CatalogSaleUsers;

